import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppContextProvider } from '../contexts/AppContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import AppRoutes from '../routes/AppRoutes';
import { ToastContainer } from './Toast';
import { useAuth } from '../hooks/useAuth';
import SessionExpirationModalContainer from './SessionExpirationModalContainer';
import { Auth0Provider } from '../auth/Auth0Provider';
import SellerIdCheck from './UserIdCheck/UserIdCheck';
import PWAInstallPrompt from './PWAInstallPrompt/PWAInstallPrompt';
import NotificationOptInPrompt from './NotificationOptInPrompt/NotificationOptInPrompt';

// Component to render session expiration modal inside Router context
const SessionManager: React.FC = () => {
  const { isSessionExpired, dismissSessionExpiredModal } = useAuth();
  
  return (
    <SessionExpirationModalContainer
      isOpen={isSessionExpired}
      onClose={dismissSessionExpiredModal}
    />
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Auth0Provider>
        <AppContextProvider>
          <NotificationProvider>
            <div className="App">
              <SellerIdCheck />
              <AppRoutes />
              <ToastContainer />
              <SessionManager />
              <PWAInstallPrompt />
              <NotificationOptInPrompt />
            </div>
          </NotificationProvider>
        </AppContextProvider>
      </Auth0Provider>
    </Router>
  );
};

export default App;
